const urlOf = (path: string) => `${window.location.origin}${path}`;

const pathwayPath = (inventoryId: number) =>
  `/communities/${inventoryId}/pathways`;

const baselinePath = (inventoryId: number) =>
  `/communities/${inventoryId}/baseline`;

const gpcPath = (inventoryId: number) => `/communities/${inventoryId}/gpc`;

const disclosuresPath = (inventoryId: number) =>
  `/communities/${inventoryId}/disclosures`;

const disclosurePath = (inventoryId: number, disclosureId: number) =>
  `/communities/${inventoryId}/disclosures/${disclosureId}`;

// The disclosure detail page selects its page via a `page` query param
// (mirrors suit's `disclosurePagePath`), so the sidebar can deep-link to
// each page without a route change.
const disclosurePagePath = (
  inventoryId: number,
  disclosureId: number,
  pageKey: string,
) => `${disclosurePath(inventoryId, disclosureId)}?page=${pageKey}`;

const scenarioPath = (inventoryId: number, scenarioId: number) =>
  `/communities/${inventoryId}/pathways/${scenarioId}`;

export {
  urlOf,
  pathwayPath,
  scenarioPath,
  baselinePath,
  gpcPath,
  disclosuresPath,
  disclosurePath,
  disclosurePagePath,
};
